import React from 'react';
import PropTypes from 'prop-types';
import WorkIcon from '@material-ui/icons/Today';
import One from '@material-ui/icons/LooksOne';
import Two from '@material-ui/icons/LooksTwo';
import Three from '@material-ui/icons/Looks3';

class EventAvatar extends React.Component {
    render() {
        switch (this.props.itemKey) {
            case 0:
                return (<WorkIcon />);
            case 1:
                return (<One />);
            case 2:
                return (<Two />);
            case 3:
                return (<Three />);
            case 4:
                return (<Three />);
            default:
                return (<WorkIcon />);
        }
    }
}

EventAvatar.propTypes = {
    itemKey: PropTypes.number.isRequired,
};

export default EventAvatar;